import { Doughnut, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Doughnut.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        legendPosition: {
            type: String,
            default: "right"
        },
        units: {
            type: String,
            required: false
        }
    },
    watch: {
        legendPosition: "rerender"
    },
    methods: {
        rerender () {
            this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        },
        value_as_string (value) {
            return numeral(value).format("0,0") + "%"
        }
    },
    computed: {
        options () {
            return {
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            return `${data.labels[tooltipItem.index]}: ${this.value_as_string(data.datasets[0].data[tooltipItem.index])}`
                        }
                    }
                },
                legend: {
                    display: true,
                    position: this.legendPosition,
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
